import type { Routes } from '@angular/router';
export const vehicleMarketRoutes: Routes = [
    {
        path: 'fahrzeugbestand',
        loadChildren: () => import('./pages/vehicles-page/vehicle.routes'),
    },
];
